import store from '@/store';
import { computed } from 'vue';
import { useActiveGroups } from './useGroups';
const useMyTeam = () => {
    const { activeGroups } = useActiveGroups();
    const team = computed(() => store.state.rooms.playingTeam);
    const teamName = computed(() => {
        if (team.value === null)
            return null;
        return team.value.name;
    });
    const teamId = computed(() => { var _a, _b; return (_b = (_a = team.value) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : ""; });
    const group = computed(() => {
        var _a;
        if (team.value === null || team.value.group === null)
            return null;
        return (_a = activeGroups.value[team.value.group]) !== null && _a !== void 0 ? _a : null;
    });
    return {
        team,
        teamId,
        group,
        teamName
    };
};
export default useMyTeam;
